import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateInspecaoItensPatrimonioCadastroColumnDefs
 */

type Props = {
  statusChecklist: number;
  onActionEditar: (idInspecaoPatrimonio: number | null, openState: boolean) => void;
  onActionDeletar: (idInspecaoPatrimonio: number | null, openState: boolean) => void;
  onEnterInspecaoPatrimonio: (idInspecaoPatrimonio: number, openNewTab: boolean) => void;
};

export const GenerateInspecaoItensPatrimonioCadastroColumnDefs = ({
  statusChecklist,
  onActionEditar,
  onActionDeletar,
  onEnterInspecaoPatrimonio,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "VNI";
      case 1:
        return "E";
      case 3:
        return "VI";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "green";
      case 3:
        return "blue";
      default:
        return "gray";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Verificação Não Iniciada";
      case 1:
        return "Encerrada";
      case 3:
        return "Verificação Iniciada";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 50,
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center">
          <ItemStatus
            textSize="extraSmall"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 200,
      width: 200,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs break-normal">
            {value ?? null}
          </div>
        );
      }
    },
    {
      field: "dataInspecao",
      filterable: false,
      headerName: "Data de Abertura",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "dataEncerramento",
      filterable: false,
      headerName: "Data de Encerramento",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "enter",
      filterable: false,
      headerName: "Registro de Inspeção",
      sortable: false,
      minWidth: 150,
      width: 150,
      valueGetter: (_, row) => { return row['idInspecaoPatrimonio'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-xs">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterInspecaoPatrimonio(value, true);
                } else {
                  onEnterInspecaoPatrimonio(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #d84a38',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Inspeção
            </Button>
          </div>
        );
      },
    },
    {
      field: "totalItens",
      filterable: false,
      headerName: "Total Itens",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalNA",
      filterable: false,
      headerName: "Total (NA)",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalA",
      filterable: false,
      headerName: "Total (A)",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalR",
      filterable: false,
      headerName: "Total (R)",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalX",
      filterable: false,
      headerName: "Total (X)",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalRA",
      filterable: false,
      headerName: "Total (RA)",
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    // {
    //   field: "exportar",
    //   filterable: false,
    //   headerName: "Relatório",
    //   sortable: false,
    //   minWidth: 95,
    //   valueGetter: (_, row) => { return row['idInspecaoObra'] as number; },
    //   renderCell: ({ value }) => {
    //     return (
    //       <div className="w-full h-full flex items-center text-xs">
    //         <Button
    //           onMouseDown={(e) => {
    //             onActionReport(value);
    //           }}
    //           sx={{
    //             fontSize: 11,
    //             paddingX: '.4rem',
    //             paddingY: 0,
    //             background: '#e6e6e6',
    //             borderLeft: '.2rem solid #35aa47',
    //             borderRadius: 0,
    //             color: 'black',
    //             fontWeight: 'normal',
    //           }}>
    //           Exportar
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
    {
      field: 'idInspecaoPatrimonio',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 120,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full">
            <div className="flex items-center justify-center w-full h-full">
              <IconButton
                disabled={statusChecklist === 1}
                onClick={() => onActionEditar(params.value, true)}>
                <DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
              </IconButton>

              <IconButton
                disabled={statusChecklist === 1}
                onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
              </IconButton>

              {/* <IconButton
                disabled={statusChecklist === 1}
                onClick={() => { onActionCopy(params.value, true) }}>
                <DynamicIcon nameIcon="ContentCopy" size={20} className="text-purple-500" />
              </IconButton> */}
            </div>
          </div>
        );
      }
    },
  ];
}